var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prt-modal',{staticClass:"prt-loader-modal",attrs:{"show":_vm.show}},[_c('div',{staticClass:"card"},[_c('prt-loader',{attrs:{"duration":3,"infinite":"","size":48}}),_c('h1',[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }